import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import {DelinkRFIDMember, RFIDMemberResponse, SaveMembers, UpdateRFIDMember } from '../../core/services/facility.model';


@Injectable({
  providedIn: 'root'
})
export class RfidMemberService {

  constructor(private httpClient: HttpClient, private httpHeaderService: HttpHeadersService) { }
  
  public getRFIDMembers(facilityId: string): Observable<RFIDMemberResponse> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this.httpClient.get(environment.servicePath + '/member/get_members_list?facilityId='+facilityId, { headers });
    return result as Observable<RFIDMemberResponse>;
  }
  public excelUpload(formdata:any): Observable<any> {
    let headers = this.httpHeaderService.bearerHttpAuthorizationHeaderWithoutContentType();
    return this.httpClient.post(environment.servicePath + '/member/upload', formdata,{ headers });
  }
  public saveRFIDMemberList(data:SaveMembers): Observable<any> {
    let headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/member/save', data,{ headers });
  }

  public updateRFIDMember(data:UpdateRFIDMember): Observable<any> {
    let headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(`${environment.servicePath}/member/edit_member`, data,{ headers });
  }

  public deleteRFIDMember(memberId:string): Observable<any> {
    let headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.delete(`${environment.servicePath}/member?memberId=${memberId}`, { headers });
  }

  public removeRFIDMembers(facilityId: string, members: DelinkRFIDMember[]) {
    let headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let data = {
      facilityId: facilityId,
      members: members
    };
    return this.httpClient.post(`${environment.servicePath}/member/delete_members`, data, { headers }).toPromise();
  }

  public delinkRFIDs(facilityId: string, members: DelinkRFIDMember[]) {
    let headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let data = {
      facilityId: facilityId,
      members: members
    };
    return this.httpClient.post(`${environment.servicePath}/member/delink_rfids`, data, { headers }).toPromise();
  }


  // getRFIDMembers(): Promise<RFIDMemberResponse> {
  //   return new Promise((resolve, reject) => {
  //     const headers = this._header.bearerHttpAuthorizationHeader();
  //     this._http.get(`${environment.servicePath}/member/get_members_list?facilityId=${this.selectedFacilityId()}`, { headers }).subscribe(
  //       (res: RFIDMemberResponse) => {
  //         resolve(res);
  //       },
  //       (err: any) => {
  //         reject(err);
  //       }
  //     );
  //   });
  // }

  // updateRFIDMember(data: UpdateRFIDMember): Promise<boolean> {
  //   return new Promise((resolve, reject) => {
  //     let headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
  //     this.httpClient.post(, data, { headers }).subscribe(
  //       (res: any) => {
  //         resolve(true);
  //       },
  //       (err: any) => {
  //         reject(err);
  //       }
  //     );
  //   });
  // }
  
}
